import React, { useState, useEffect } from 'react';
import { FaStar, FaRegStar } from 'react-icons/fa';
import axios from 'axios';
import '../styles/StarRating.css';

const API = process.env.REACT_APP_API_URL || '';

function StarRating({ type, id, size = 'sm' }) {
  const [rating, setRating] = useState(0);
  const [average, setAverage] = useState(null);
  const [count, setCount] = useState(0);
  const [hover, setHover] = useState(0);

  useEffect(() => {
    if (id) loadRating();
  }, [type, id]);

  const loadRating = async () => {
    try {
      const res = await axios.get(`${API}/api/ratings/${type}/${id}`);
      setRating(res.data.userRating || 0);
      setAverage(res.data.average);
      setCount(res.data.count);
    } catch (e) { /* ignore */ }
  };

  const rate = async (value) => {
    try {
      if (value === rating) {
        await axios.delete(`${API}/api/ratings/${type}/${id}`);
        setRating(0);
      } else {
        await axios.post(`${API}/api/ratings/${type}/${id}`, { rating: value });
        setRating(value);
      }
      loadRating();
    } catch (e) { console.error(e); }
  };

  return (
    <div className={`star-rating ${size}`}>
      <div className="stars">
        {[1, 2, 3, 4, 5].map(i => (
          <span key={i} className={`star ${(hover || rating) >= i ? 'filled' : ''}`}
            onClick={(e) => { e.stopPropagation(); rate(i); }}
            onMouseEnter={() => setHover(i)}
            onMouseLeave={() => setHover(0)}>
            {(hover || rating) >= i ? <FaStar /> : <FaRegStar />}
          </span>
        ))}
      </div>
      {average && <span className="rating-avg">{average} ({count})</span>}
    </div>
  );
}

export default StarRating;
